import { compose } from 'redux';
import { connect } from 'react-redux';
import HomePage from '../../pages/Home/HomePage';
import withAuthUser from '../../common/WithAuthUser';
import * as Action from '../../actions/Home';
import { FreeLoginRequested } from '../../actions/Auth';
import {
    getSettingCustomTextRequested, getSettingCustomTextClear, 
    getSettingCustomCommentRequest, getSettingCustomCommentClear,
    getSettingCustomTimerctrlRequest, getSettingCustomTimerctrlClear,
} from '../../actions/AdminSettingCustom';

import Header from '../../pages/Home/HeaderUser';
import { changeLanguageActions } from '../../actions/Locale';

const mapStateToProps = (state) => ({
    locale: state.locale.lang.current,
    eventInfo: state.registration.registrationViewer.data,
    adsData: state.home.getAdvertisement.data,
    isAuthorized: state.auth.credential.isAuthorized,
    role: state.auth.credential.data.role,
    isLoading: state.registration.registrationViewer.isFetching || state.home.loginOuterServer.isFetching,
    errorLoginOuterServer: state.home.loginOuterServer.errors,
    dataLoginOuterServer: state.home.loginOuterServer.data,
    customColor: state.registration.registrationViewer.data?.settings_colors_viewer,
    customText: state.adminSettingCustom.getCustomText.data?.content,
    customComment: state.adminSettingCustom.getCustomComment.data,
    customTimerctrl: state.adminSettingCustom.getCustomTimerctrl.data,
});

const mapDispatchToProps = (dispatch) => ({
    getAdvertisement: (action) => {
        dispatch(Action.getAdvertisementRequested(action));
    },
    clearAdvertisement: () => {
        dispatch(Action.clearAdvertisement());
    },
    loginOuterServer: (action) => {
        dispatch(Action.loginOuterServerRequest(action));
    },
    clearLoginOuterServer: () => {
        dispatch(Action.clearLoginOuterServer());
    },
    freeLogin: (params) => {
        dispatch(FreeLoginRequested(params));
    },
    getCustomText: (params) => {
        dispatch(getSettingCustomTextRequested(params));
    },
    clearCustomText: () => {
        dispatch(getSettingCustomTextClear());
    },
    getSettingCustomComment: (params) => {
        dispatch(getSettingCustomCommentRequest(params));
    },
    clearGetSettingCustomComment: () => {
        dispatch(getSettingCustomCommentClear());
    },

    getSettingCustomTimerctrl: (params) => {
        dispatch(getSettingCustomTimerctrlRequest(params));
    },
    clearGetSettingCustomTimerctrl: () => {
        dispatch(getSettingCustomTimerctrlClear());
    },


    changeLanguage: (param) => {
        dispatch(changeLanguageActions(param));
    },
});

export const HomeHeader = connect(mapStateToProps, mapDispatchToProps)(Header);

export default compose(
    withAuthUser,
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
)(HomePage);
